import { render, staticRenderFns } from "./SyncOrderButton.vue?vue&type=template&id=2e211cd5&scoped=true"
import script from "./SyncOrderButton.vue?vue&type=script&lang=js"
export * from "./SyncOrderButton.vue?vue&type=script&lang=js"
import style0 from "./SyncOrderButton.vue?vue&type=style&index=0&id=2e211cd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e211cd5",
  null
  
)

export default component.exports